module.exports = __webpack_public_path__ + "img/hoverBox5.35de48e9.png";